<template>
  <div>
    <page-header :header="currentIndex.title" />

    <draft-hoc class="mt-4" />
  </div>
</template>

<script>
import {Vue, Component, namespace} from 'nuxt-property-decorator'
import { warningNotification } from '@/notifications'
import DraftHoc from './components/DraftHOC.vue'

@Component({
  components: {
    DraftHoc,
  },
})
export default class IndexEditView extends Vue {
  @namespace('indices').Getter currentIndex
  @namespace('indices').Action getCurrentIndex

  async created () {
    try {
      await this.getCurrentIndex({slug: this.$route.params.slug})
    } catch (error) {
      this.$notify(warningNotification('Something went wrong.'))
      this.$router.push('/indices')
    }
  }
}
</script>
